import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { DSSetup, Service } from 'webapp-types';
import { BillingFeature, MetricDetailsTab } from 'webapp/enums/enums';
import { getPreviewChangeIndicatorClass } from 'webapp/utils/data';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

import MetricSetup from 'webapp/models-custom/metric-setup';

interface Args {
	text: string;
	valueString?: string | null;
	changeString?: string | null;
	inverted?: boolean;
	metricSetupData?: DSSetup.MetricSetupWithoutFiltersData | null;
	path?: string;
	tooltipText?: string | null;
	lockedText?: string;
}

export default class GoalValueQueryComponent extends Component<Args> {
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('billing') declare billingService: Service.Billing;
	@service('metric-details') declare metricDetailsService: Service.MetricDetails;
	@service('model-manager/metrics')
	declare mmMetricsService: Service.ModelManager.Metrics;

	get valueString() {
		return this.args.lockedText || this.args.valueString || 'No data';
	}

	get indicatorClass() {
		return getPreviewChangeIndicatorClass(this.args.changeString || '', !!this.args.inverted);
	}

	get isLocked() {
		return !!this.args.lockedText;
	}

	get metricSetupData() {
		return this.args.metricSetupData;
	}

	get isLink() {
		return this.metricSetupData && this.args.path;
	}

	get tooltipText() {
		return this.args.tooltipText;
	}

	@action
	click() {
		if (this.isLink) {
			if (this.isLocked) {
				this.billingService.checkIfCan(BillingFeature.GOALS_FORECASTS, true);
			} else {
				const metricSetup = new MetricSetup(this.metricSetupData || {});

				if (this.args.path?.includes('forecast')) {
					this.metricDetailsService.openMetricDetailsDrawer({
						metricSetup,
						tab: MetricDetailsTab.FORECAST,
					});
				}
			}
		}
	}
	<template>
		<div
			role="button"
			class="value-preview {{if this.isLink 'link'}}"
			{{on "click" this.click}}
		>
			{{#if this.isLocked}}<CommonUiIconComponent @name="Lock" @size="sm" />{{/if}}
			{{@text}}
			<strong>
				{{this.valueString}}
			</strong>
			{{#if @changeString}}
				<span class="indicator {{this.indicatorClass}}">
					{{@changeString}}
				</span>
			{{/if}}
			{{#if this.tooltipText}}
				<div class="error">
					<ToolTipWithIconComponent
						@text={{{this.tooltipText}}}
						@iconName="AlertFill"
						@maxWidth={{230}}
					/>
				</div>
			{{/if}}
			{{#if this.isLink}}
				<CommonUiIconComponent @name="External" @size="xs" />
			{{/if}}
		</div>
	</template>
}
